import { Typography } from "@mui/material";
import get from "lodash/get";
import { sanitizeFieldRestProps, TextFieldProps, useRecordContext } from "react-admin";
import { Money } from "../misc/Money";
import { autovioColors } from "../misc/backofficeTheme";

/** Can render `Money` fields as well as `Cents` fields. */
export function MoneyField(props: TextFieldProps & { hide0?: boolean; redForNegativeValues?: boolean }) {
  const { className, source, hide0, redForNegativeValues, style, ...rest } = props;
  const record = useRecordContext(props);
  let value = get(record, source ?? "");
  const typopgraphyStyle = {
    ...style,
    ...(redForNegativeValues && value < 0 ? { color: autovioColors.red } : {}),
  };

  // If value is a `Money` object, extract the amount ...
  if (value && typeof value === "object" && value.currency === "EUR") {
    value = value.amount * 100;
  }
  if (typeof value !== "number" || !isFinite(value) || (value === 0 && hide0)) {
    return null;
  }

  return (
    <Typography
      component="span"
      variant={props.variant || "body2"}
      className={className}
      style={typopgraphyStyle}
      {...sanitizeFieldRestProps(rest)}
    >
      <Money cents={value} style={value < 0 ? { color: autovioColors.red } : undefined} />
    </Typography>
  );
}
